import React from "react";

const CardItem = (props) => {
  const { imgUrl, title, desc } = props.item;

  return (
    <div className="single__free__course">
      <div className="free__course__img mb-5">
        <img src={imgUrl} alt="" className="w-100" />
        <button className="btn free__btn" title={desc}>Посмотреть</button>
      </div>

      <div className="free__course__details">
        <h6>{title}</h6>

      </div>
    </div>
  );
};

export default CardItem;
